import IframeActivity from "./IframeActivity";

export default function WhyShouldI() {
    return (
        <IframeActivity
            src="/activities/why-should-i/index.html"
            title="Why Should I?"
        />
    );
}